import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TarobaseDemo from './TarobaseDemo';;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <TarobaseDemo />
  </React.StrictMode>
);
